// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-widgets-container{display:flex;margin-bottom:.25rem;margin-top:.5rem}.v-widgets-container__wrapper{display:flex}@media(max-width:767.98px){.v-widgets-container__wrapper{overflow-x:auto}.v-widgets-container__wrapper.row{margin-left:0;margin-right:0}.v-widgets-container__wrapper .v-widget{flex:1 0 100%}}.v-widgets-container .v-widget:not(:first-child){margin-left:1.5rem;margin-top:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
